import Layout from '@/layout'

const houseKeeperRouter = {
  path: '/house_keeper',
  component: Layout,
  redirect: 'house_keeper/task_assignment',
  name: 'Nested',
  meta: {
    title: 'Buồng',
    icon: ''
  },
  children: [
    {
      path: '/house_keeper/task_assignment',
      name: 'abc',
      meta: {
        title: 'Phân lịch dọn phòng',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/taskAssignment.vue')
    },
    {
      path: '/house_keeper/room_condition',
      name: '',
      meta: {
        title: 'Tình trạng buồng phòng',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/roomCondition.vue')
    },
    // {
    //   path: '/house_keeper/room_condition',
    //   name: '',
    //   // redirect: '/group/search_group_master',
    //   component: () => import('@/views/nested/menu1/index') // Parent router-view
    //   // children: [
    //   //   {
    //   //     path: '/group/search_group_master',
    //   //     component: () => import('@/views/mci/group/searchGroupMaster.vue')
    //   //   },
    //   //   {
    //   //     path: '/group/group_master_functions',
    //   //     name: '',
    //   //     component: () => import('@/views/mci/group/groupMasterFunctions.vue')
    //   //   }
    //   // ]
    // },
    {
      path: '/house_keeper/current_status',
      name: '',
      meta: {
        title: 'Trạng thái khách sạn',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/currentStatus.vue')
    },
    {
      path: '/house_keeper/housekeeping_service',
      name: '',
      meta: {
        title: 'Dịch vụ buồng phòng',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/houseKeepingService.vue')
    },
    {
      path: '/house_keeper/lost_and_found',
      name: '',
      meta: {
        title: 'Đồ thất lạc',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/lostAndFound.vue')
    },
    {
      path: '/house_keeper/ooo_room',
      name: '',
      meta: {
        title: 'Phòng ngưng sử dụng',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/oooRoom.vue')
    },
    {
      path: '/house_keeper/maintain_job_dashboard',
      name: '',
      meta: {
        title: 'Quản lý yêu cầu',
        icon: ''
      },
      component: () =>
        import('@/views/mci/houseKeeper/maintainJobDashboard.vue')
    },
    {
      path: '/house_keeper/maintain_job_processing',
      name: '',
      meta: {
        title: 'Xử lý và tiếp nhận yêu cầu',
        icon: ''
      },
      component: () =>
        import('@/views/mci/houseKeeper/maintainJobProcessing.vue')
    },
    {
      path: '/house_keeper/maintenance_config',
      meta: {
        title: 'Cấu hình bảo trì',
        icon: ''
      },
      component: () => import('@/views/nested/menu1/index'),
      redirect: '/house_keeper/maintenance_config/repair_location',
      children: [
        {
          meta: {
            title: 'Vị trí bảo trì',
            icon: ''
          },
          path: '/house_keeper/maintenance_config/repair_location',
          component: () => import('@/views/mci/houseKeeper/repairLocation.vue')
        },
        {
          meta: {
            title: 'Loại việc',
            icon: ''
          },
          path: '/house_keeper/maintenance_config/type_of_work',
          component: () => import('@/views/mci/houseKeeper/typeOfWork.vue')
        }
      ]
    },
    {
      path: '/house_keeper/room_map',
      name: '',
      meta: {
        title: 'Sơ đồ phòng',
        icon: ''
      },
      component: () => import('@/views/mci/houseKeeper/hk-roomMap/index.vue')
    }
  ]
}

export default houseKeeperRouter
